import { useMutation } from "@vue/apollo-composable";
import {
  AccountDocument,
  AccountsDocument,
  BusinessAccountsDocument,
  BusinessesDocument,
  OpenAccountDocument,
  type OpenAccountMutationVariables,
  OpenTermDepositDocument,
  type TermDepositInput,
  TransactionsDocument,
} from "@/api/generated/graphql";

export const accountsQuery = AccountsDocument;
export const accountQuery = AccountDocument;
export const transactionsQuery = TransactionsDocument;
export const businessesQuery = BusinessesDocument;
export const businessAccountsQuery = BusinessAccountsDocument;

export async function openAccount({ type, name, businessId }: OpenAccountMutationVariables) {
  const { onDone, onError, mutate } = useMutation(OpenAccountDocument);
  const res = new Promise((resolve, reject) => {
    onDone(result => resolve(result));
    onError(error => reject(error));
  });

  await mutate({ type, name, businessId });
  return res;
}

export async function openTermDepositAccount(input: TermDepositInput) {
  const { onDone, onError, mutate } = useMutation(OpenTermDepositDocument);
  const res = new Promise((resolve, reject) => {
    onDone(result => resolve(result));
    onError(error => reject(error));
  });

  await mutate({ input });
  return res;
}
